export const Constants = Object.freeze({
    DASHBOARD: 'dashboard',
    EDIT: 'Edit',
    EDIT_DATES: 'EditDates',
    MAKE_CORRECTIONS: 'MakeCorrections',
    USER_ENTRY: 'UserEntry',
    USER_ENTRY_IDENTIFIER: "_USER_ENTRY_",
    YES_FLAG: 'Y',
    NO_FLAG: 'N',
    SYSTEM: 'system',
    VIEW: 'View',
    OVERRIDE: 'override',
    CREDIT_MEMO: 'CreditMemo',
    POST_IN_PROGRESS: 'Post In Progress',
    ARCHIVE: 'archive',
    TEST: "Test",
    REPLACE: "Replace",
    INVOICE_LIST_SOURCE: 'invoiceList',
    APPROVAL: 'Approval',
    SOURCE_INVOICE_REPORT: 'VendorInvoicesReport',
    SOURCE_DASHBOARD_GADGET : 'DashboardGadget'
});


export const ConstantsSymbols = Object.freeze({
    TAXKEYS_DELIM: '||'
});

export const AssetPaths = Object.freeze({
    PDF_ICON: '/images/pdf-icon.png',
    PNG_ICON:'/images/img-icon.png'
});